
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/leads/tayara-pro",
      function () {
        return require("private-next-pages/leads/tayara-pro.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/leads/tayara-pro"])
      });
    }
  